import { Sentry } from '../utils/sentry'
import styles from './ErrorBoundary.module.css'

interface ErrorBoundaryProps {
  children: React.ReactNode
}

function ErrorFallback() {
  return (
    <div className={styles.container}>
      <div className={styles.icon} aria-hidden="true">!</div>
      <h1 className={styles.title}>Algo salió mal</h1>
      <p className={styles.message}>
        Algo salió mal. Intenta recargar la página.
      </p>
      <button
        className={styles.button}
        onClick={() => window.location.reload()}
        type="button"
      >
        Recargar
      </button>
    </div>
  )
}

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  )
}
